import { CustomerType } from "@origin-digital/platform-enums";
import { CommonParameters, IMcAppType, NavFlow, Tab } from "../mcApp.types";

export const currentPlans: IMcAppType = {
  name: "currentPlans_SAP",
  path: `/my-account/current-plans`,
  description: "Display the current plans",
  parameters: {
    required: ["caid"],
    properties: { caid: CommonParameters.caid },
  },
  navFlow: NavFlow.STANDARD,
  title: "Current plans",
  parent: Tab.MORE,
  conditions: {
    intent: "currentPlans",
    customerType: CustomerType.sap,
  },
};
